export default "__VITE_ASSET__CARuX48A__"